import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../components/Button'
import Icon from '../../../components/Icon'
import Private from '../../../components/Private'
import Text from '../../../components/Text'
import routes from '../../../config/routes'
import { Container } from '../styles'

interface Props {

}

const SecurityScreen: React.FC<Props> = () => {
  const history = useHistory()

  return (
    <Private>
      <Text
        tag="h1"
      >
        <Button
          label={(
            <Icon
              name="close"
            />
          )}
          small
          backgroundColor="transparent"
          onClick={() => history.push(routes.settings.menu.path)}
        />
        {' '}Segurança
      </Text>
      <Container>
        <div
          style={{ marginTop: '12px' }}
          onClick={() => history.push(routes.settings.security.password.path)}
        >
          <Button
            style={{ float: 'left' }}
            before={(
              <Icon
                name="password"
              />
            )}
            label="Alterar senha"
            backgroundColor="transparent"
            fontColor="darkGray"

          />
          <Button
            style={{ float: 'right' }}
            after={(
              <Icon

                name="arrow"
              />
            )}
            label=""
            backgroundColor="transparent"
            fontColor="darkGray"
          />

        </div>
        <div
          style={{ marginTop: '18px' }}
          onClick={() => history.push(routes.settings.security.session.path)}
        >
          <Button
            style={{ float: 'left' }}
            before={(
              <Icon
                name="smartphone"
              />
            )}
            label="Sessões ativas"
            backgroundColor="transparent"
            fontColor="darkGray"

          />
          <Button
            style={{ float: 'right' }}
            after={(
              <Icon

                name="arrow"
              />
            )}
            label=""
            backgroundColor="transparent"
            fontColor="darkGray"
          />
        </div>
      </Container>
    </Private>
  )
}

export default SecurityScreen
